<div class="filter-results">
    <!-- <div *ngFor="let result of results">
        <div *ngFor="let items of result"> -->

    <!-- {{[ item.numberOfRooms, item.floorNumber, item.number, item.airDirection, item.balconiesSize, item.flatSize,
                item.gardenSize, item.status, item.buildingName ]}} -->
    <div class="top-holder">
        <div class="title-holder-top">
            <span>{{ 'SEARCH-PROJ-ON-MAP' | translate }}</span>   <span *ngIf="this.projects"> {{ this.compTitle }} - {{ 'CONSTRACTION-PROJECTS' | translate }}: {{ this.projects.length }}</span> 
        </div>
        <!-- <div class="statistics">
            <span class="free" matBadge="{{ freeStatusCounter }}" matBadgeOverlap="false">פנוי</span>
            <span class="waiting waitingStatistics" matBadge="{{ waitingStatusCounter }}" matBadgeOverlap="false"
                matBadgeColor="yellow">בהמתנה</span>
            <span class="sold soldStatisctics" matBadge="{{soldStatusCounter }}" matBadgeOverlap="false">נמכר</span>
        </div> -->
        <form (ngSubmit)='updateItem(filter);'>
            <div class="top-holder-filters title-holder sub-title">
                <div class="icon-holder"></div>
                <div class="title"> {{ 'FILTER-BY' | translate }}: </div>
                <div class="dropdown-trigger" [class.active]="showFilters"></div>
            </div>
            <label class="proj-names">
                <h4>{{ 'PROJECTS' | translate }}</h4>
                <mat-form-field appearance="outline">
                    <!-- <mat-label> {{ 'ALL' | translate }}</mat-label> -->
                    <mat-select matNativeControl [(ngModel)]='filter.projects' multiple name="projects">
                        <!-- <mat-option *ngFor="let status of statusArray" value="{{ status }}" selected>{{ status }}</mat-option> -->
                        <mat-option *ngFor="let project of projects" value="{{ project.id }}" selected>
                            <!-- <a [routerLink]="['/user/jim']">{{ project.title }}</a> -->
                            {{ project.title }}
                        </mat-option>
                    </mat-select>
                    <mat-label>{{ 'ALL' | translate }}</mat-label>
                </mat-form-field>
            </label>
            <label class="status">
                <h4>{{ 'STATUS' | translate }}</h4>
                <mat-form-field appearance="outline">
                    
                    <mat-select matNativeControl [(ngModel)]='filter.status' multiple name="status">
                        <!-- <mat-option *ngFor="let status of statusArray" value="{{ status }}" selected>{{ status }}</mat-option> -->
                        <mat-option *ngFor="let status of statusArray" value="{{ status }}" selected>
                            <container-element [ngSwitch]="status">
                                <div *ngSwitchCase="'free'">{{ 'FREE' | translate }}</div>
                                <div *ngSwitchCase="'waiting'">{{ 'IN-REGISTRATION' | translate }}</div>
                                <div *ngSwitchCase="'sold'">{{ 'SOLD' | translate }}</div>
                            </container-element>
                        </mat-option>
                    </mat-select>
                    <mat-label>{{ 'ALL' | translate }}</mat-label>
                </mat-form-field>
            </label>
            <label class="number-of-rooms">
                <h4>{{ 'NUMBER-OF-ROOMS' | translate }}</h4>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'FROM' | translate }}</mat-label>
                    <mat-select matNativeControl [(ngModel)]='filter.numberOfRoomsFrom' placeholder="numberOfRoomsFrom"
                        name="numberOfRoomsFrom">
                        <mat-option type="number" selected value="0">{{ 'ALL' | translate }}</mat-option>
                        <mat-option type="number" *ngFor="let numberOfRooms of numberOfRoomsArray"
                            value="{{ numberOfRooms }}">{{ numberOfRooms }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </label>
            <label>
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'UNTIL' | translate }}</mat-label>
                    <mat-select matNativeControl [(ngModel)]='filter.numberOfRoomsUntil'
                        placeholder="numberOfRoomsUntil" name="numberOfRoomsUntil">
                        <mat-option type="number" selected value="0">{{ 'ALL' | translate }}</mat-option>
                        <mat-option type="number" *ngFor="let numberOfRooms of numberOfRoomsArray"
                            value="{{ numberOfRooms }}">{{ numberOfRooms }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </label>
            <label class="area-appartment">
                <h4>{{ 'APARTMENT-AREA' | translate }}</h4>
                <mat-form-field class="example-full-width" appearance="outline">
                    <!-- <mat-label>{{ 'FROM' | translate }}</mat-label> -->
                    <input matInput type="number" [(ngModel)]='filter.areaFrom' name="areaFrom" value="0" placeholder="0">
                </mat-form-field>
            </label>
            <label>
                <mat-form-field class="example-full-width" appearance="outline">
                    <!-- <mat-label>{{ 'UNTIL' | translate }}-</mat-label> -->
                    <input matInput type="number" [(ngModel)]='filter.areaUntil' name="areaUntil" value="0" placeholder="0">
                </mat-form-field>
            </label>
            <label>
                <h4>{{ 'AIR-DIRECTION' | translate }}</h4>
                <mat-form-field appearance="outline">
                    <mat-select matNativeControl [(ngModel)]='filter.airDirection' name="airDirectionArray" placeholder="{{ 'ALL' | translate }}">
                      
                        <mat-option *ngFor="let airDirection of airDirectionArray" value="{{ airDirection }}">{{
                            airDirection }}</mat-option>
                    </mat-select>
                    <mat-label>{{ 'ALL' | translate }}</mat-label>
                </mat-form-field>
            </label>

            <!-- <mat-form-field appearance="outline">
                <mat-select matNativeControl [(ngModel)]='filter.projects' multiple name="projects">

                    <mat-option *ngFor="let project of projects" value="{{ project.id }}" selected>
                        {{ project.title }}
                    </mat-option>
                </mat-select>
                <mat-label> {{ 'ALL' | translate }}</mat-label>
            </mat-form-field> -->
       

            <!-- <label>{{ 'UNTIL' | translate }} מספר חדרים:
                        <input [(ngModel)]='filter.numberOfRooms' placeholder="numberOfRooms" name="numberOfRooms">
                      </label> -->
            <button type="submit" value="submit" class="btn-unika search">{{ 'SEARCH' | translate }}<i class="fa fa-search"></i></button>
        </form>
    </div>
    <div class="content-holder" *ngIf="dataSource.data.length > 0">
        <!-- <table mat-table #table [dataSource]="dataSource">

            <ng-container matColumnDef="numberOfRooms">
                <th mat-header-cell *matHeaderCellDef> מספר חדרים </th>
                <td mat-cell *matCellDef="let result"> {{result.numberOfRooms}} </td>
            </ng-container>


            <ng-container matColumnDef="floorNumber">
                <th mat-header-cell *matHeaderCellDef> מספר קומה </th>
                <td mat-cell *matCellDef="let result"> {{result.floorNumber}} </td>
            </ng-container>

     
            <ng-container matColumnDef="airDirection">
                <th mat-header-cell *matHeaderCellDef> כיוון אוויר </th>
                <td mat-cell *matCellDef="let result"> {{result.airDirection}} </td>
            </ng-container>


            <ng-container matColumnDef="flatSize">
                <th mat-header-cell *matHeaderCellDef> שטח הדירה</th>
                <td mat-cell *matCellDef="let result"> {{result.flatSize}} </td>
            </ng-container>

            <ng-container matColumnDef="balconiesSize">
                <th mat-header-cell *matHeaderCellDef> שטח מרפסות</th>
                <td mat-cell *matCellDef="let result"> {{result.balconiesSize}} </td>
            </ng-container>

            <ng-container matColumnDef="gardenSize">
                <th mat-header-cell *matHeaderCellDef> שטח גינה</th>
                <td mat-cell *matCellDef="let result"> {{result.gardenSize}} </td>
            </ng-container>



            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> סטטוס</th>

                <td mat-cell *matCellDef="let result"><span class="{{result.status}}"></span>
                    <container-element [ngSwitch]="result.status">
                        <div *ngSwitchCase="'free'">פנוי</div>
                        <div *ngSwitchCase="'waiting'">בהמתנה</div>
                        <div *ngSwitchCase="'sold'">נמכר</div>
                    </container-element>
                </td>
            </ng-container>

            <ng-container matColumnDef="buildingName">
                <th mat-header-cell *matHeaderCellDef> שם הבניין</th>
                <td mat-cell *matCellDef="let result"> {{result.buildingName}} </td>
            </ng-container>

            <ng-container matColumnDef="projectName">
                <th mat-header-cell *matHeaderCellDef> שם הפרויקט</th>
                <td mat-cell *matCellDef="let result"> {{result.projName}} </td>
            </ng-container>

            <ng-container matColumnDef="moreTrigger">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let result"> <button>more</button> </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table> -->
        <button (click)="closeF()" class="close-btn"></button>
        <mat-table #table [dataSource]="dataSource">
            <!-- <table mat-table *ngFor="result of results | filter: filterArray" class="mat-elevation-z8"> -->
            <!-- Position Column -->

            <ng-container matColumnDef="moreTrigger">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let result">
                    <button color="primary" (click)="openFlat(result)"
                        aria-label="send to appartment properties" class="more-btn mat-mini-fab"></button>
                </mat-cell>

            </ng-container>

            <ng-container matColumnDef="numberOfRooms">
                <mat-header-cell *matHeaderCellDef> {{ 'NUMBER-OF-ROOMS' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let result"> {{result.numberOfRooms}} </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="floorNumber">
                <mat-header-cell *matHeaderCellDef>{{ 'FLOOR-NUMBER' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let result"> {{result.floorNumber}} </mat-cell>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="airDirection">
                <mat-header-cell *matHeaderCellDef>{{ 'AIR-DIRECTION' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let result"> {{result.airDirection}} </mat-cell>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="flatSize">
                <mat-header-cell *matHeaderCellDef>{{ 'APARTMENT-AREA' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let result"> {{result.flatSize}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="balconiesSize">
                <mat-header-cell *matHeaderCellDef>{{ 'BALCONIES-AREA' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let result"> {{result.balconiesSize}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="gardenSize">
                <mat-header-cell *matHeaderCellDef>{{ 'GARDEN-AREA' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let result"> {{result.gardenSize}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef>{{ 'STATUS' | translate }}</mat-header-cell>
                <!-- <td mat-cell *matCellDef="let result"><span class="{{result.status}}"></span> {{result.status}} </td> -->
                <mat-cell *matCellDef="let result">
                    <!-- <span class="{{result.status}}"></span> -->
                    <container-element class="{{result.status}}" [ngSwitch]="result.status">
                        <div *ngSwitchCase="'free'" class='green'>{{ 'FREE' | translate }}</div>
                        <div *ngSwitchCase="'waiting'" class='yellow'>{{ 'IN-REGISTRATION' | translate }}</div>
                        <div *ngSwitchCase="'sold'" class='red'>{{ 'SOLD' | translate }}</div>
                    </container-element>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="buildingName">
                <mat-header-cell *matHeaderCellDef>{{ 'BUILDING-NAME' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let result"> {{result.buildingName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="projectName">
                <mat-header-cell *matHeaderCellDef>{{ 'PROJ-NAME' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let result"> {{result.projName}} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        <!-- <mat-paginator [pageSizeOptions]="[5, 10, 20]" aria-label="Select page of periodic elements">
        </mat-paginator> -->
        <!-- <mat-paginator #paginator [pageSize]="3" [pageSizeOptions]="[3, 5, 10, 25, 100]"
                        aria-label="Select page"
                      (page)="onChangedPageSize($event)">
                    </mat-paginator> -->
        <mat-paginator #paginator [pageSize]="this.pageSize" [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page">
        </mat-paginator>
    </div>
</div>